import React from 'react'
import PropTypes from 'prop-types'
import { NumberValidation } from '../validation'
import './input_number_spinner_component.scss'

// TODO: should replace to InputNumber component
export default class InputNumberSpinner extends React.Component{
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  onClick(i) {
    const value = this.props.value + i
    this.updateValue(value)
  }

  onLeftClick(i) {
    const value = this.props.value + i
    this.updateValue(value, { button: 'left' })
  }

  onChange(e) {
    const value = e.target.value.replace(/[０-９]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
    })
    this.updateValue(value)
  }

  updateValue(value, opts = {}) {
    if (typeof value != 'number') {
      value = Number(value)
    }
    const v = new NumberValidation(value)

    if (opts.button === 'left' && v.validNumberMin(this.props.min)) {
      this.props.update({ [this.props.element]: value })
    }

    if (v.validNumberMin(this.props.min) && (this.props.max == -1 || v.validNumberMax(this.props.max))) {
      this.props.update({ [this.props.element]: value })
    }
  }

  render() {
    const error = this.props.error.length > 0 ? <div className="error">{this.props.error}</div> : ""
    const isMin = this.props.value <= this.props.min
    const isMax = this.props.value >= this.props.max
    return(
      <div>
        <dl className="sb-input-wrap">
          <dt className="sb-input-title" styleName="sb-input-title">{this.props.children}</dt>
          <dd className="sb-input-box">
            <div className="sb-input-box-left" styleName={"sb-input-box-left" + (isMin ? " disabled" : "")} onClick={this.onLeftClick.bind(this, -1)} />
            <div className="sb-input-box-center">
              <input className="sb-input" styleName="sb-input" type="number" value={this.props.value} onChange={this.onChange.bind(this)} />
            </div>
            <div className="sb-input-box-right" styleName={"sb-input-box-right" + (isMax ? " disabled" : "")} onClick={this.onClick.bind(this, 1)} />
          </dd>
        </dl>
        {error}
      </div>
    )
  }
}

InputNumberSpinner.propTypes = {
  element: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  update: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  error: PropTypes.string
}

InputNumberSpinner.defaultProps = {
  element: "key",
  value: 0,
  update: () => {},
  min: 0,
  max: -1,
  error: ""
}
